/* eslint-env jest */
import BuyAllCard from './index';
import { FREE_MAGNETS_RIBBON } from './buyAllCardModel';

// BuyAllCard is a plain function component (no hooks when customer/packageId
// are omitted, which skips the AbsolutePosImgs composite), so we invoke it
// directly and walk the element tree -- same technique as AbsolutePosImgs.test.
const texts = (node, acc = []) => {
  if (node == null || typeof node === 'boolean') return acc;
  if (typeof node === 'string' || typeof node === 'number') { acc.push(String(node)); return acc; }
  if (Array.isArray(node)) { node.forEach((n) => texts(n, acc)); return acc; }
  if (node.props) texts(node.props.children, acc);
  return acc;
};

const option = { id: 2861, name: 'All Digital Package', price: 49.94 };
const render = (offer) => texts(BuyAllCard({
  option, offer, onClick: () => {}, label: 'Download All My Photos', customer: null, packageId: null,
})).join(' ');

describe('BuyAllCard ribbon', () => {
  it('suppresses the ribbon during the magnet window -- the banner art carries the headline', () => {
    const out = render({ couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0 });
    expect(out).not.toContain(FREE_MAGNETS_RIBBON);
    expect(out).toContain('$49.94'); // live price still renders in the pill area
  });

  it('still shows the % ribbon for a percentage offer', () => {
    expect(render({ couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20 })).toContain('20% OFF');
  });

  it('shows no ribbon with no offer', () => {
    const out = render(null);
    expect(out).not.toContain('OFF');
    expect(out).not.toContain(FREE_MAGNETS_RIBBON);
  });
});
